import React from 'react';
import { Leaf, Users, Recycle, Target } from 'lucide-react';

const Mission: React.FC = () => {
  const impacts = [
    {
      icon: <Recycle size={48} />,
      title: "Material Reciclado",
      description: "Cada cartera da nueva vida a anillas de lata que serían desechadas",
      stat: "100% Reciclado"
    },
    {
      icon: <Users size={48} />,
      title: "Empoderamiento Femenino",
      description: "Brindamos oportunidades laborales a mujeres de áreas rurales",
      stat: "Mujeres Empoderadas"
    },
    {
      icon: <Leaf size={48} />,
      title: "Impacto Ambiental",
      description: "Reducimos residuos transformándolos en productos útiles y hermosos",
      stat: "Cero Desperdicio"
    }
  ];

  return (
    <section className="mission-section">
      <div className="container">
        <div className="mission-header">
          <Target size={32} />
          <h2 className="section-title">Nuestra Misión</h2>
          <p className="mission-statement">
            "Recicla lo que puedas reciclar y crea"
          </p>
        </div>

        <div className="impact-grid">
          {impacts.map((impact, index) => (
            <div key={index} className="impact-card">
              <div className="impact-icon">
                {impact.icon}
              </div>
              <h3 className="impact-title">{impact.title}</h3>
              <p className="impact-description">{impact.description}</p>
              <div className="impact-stat">{impact.stat}</div>
            </div>
          ))}
        </div>

        <div className="mission-content">
          <div className="mission-text">
            <h3>Transformando Residuos en Arte</h3>
            <p>
              En Segunda Vida creemos que cada material merece una segunda oportunidad.
              Lo que para muchos es desperdicio, para nosotros es el inicio de una
              nueva historia llena de posibilidades.
            </p>
            <p>
              Nuestro proceso artesanal no solo crea productos únicos, sino que también
              genera impacto social positivo al brindar trabajo digno a mujeres talentosas
              que anteriormente carecían de oportunidades laborales.
            </p>
          </div>

          <div className="mission-values">
            <h3>¿Por qué elegir Segunda Vida?</h3>
            <ul className="values-list">
              <li>
                <strong>Sostenibilidad:</strong> Cada compra reduce el impacto ambiental
              </li>
              <li>
                <strong>Calidad Artesanal:</strong> Productos únicos hechos con dedicación
              </li>
              <li>
                <strong>Impacto Social:</strong> Apoyas directamente a mujeres emprendedoras
              </li>
              <li>
                <strong>Historia Auténtica:</strong> Cada cartera tiene una historia real detrás
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;